/**
 * Used to connect react-sizes to components.
 *
 * @param width
 *
 * @returns {{isMobile: boolean}}
 */
export const mapSizesToProps = ({ width }) => ({
    width,
    isMobile: width < 768,
    isTablet: width > 425 && width <= 768
});

/**
 * Check if the given object has all the given properties set.
 *
 * @param data The object data to check
 * @param properties An array of properties to check
 *
 * @returns {boolean}
 */
export const propertiesAreSet = (data, properties) => properties.filter(property => data[property] !== undefined).length === properties.length;



// WEBPACK FOOTER //
// ./src/utils.js